var _rect, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 25",
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24.118,
    rx: 5,
    fill: "#D8D8D8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24.118,
    rx: 5,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.914h40.936V0H0v23.914z",
    fill: "#0D338E"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EFC744"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.434 1.98l.368 1.135h1.193l-.965.7.369 1.136-.965-.702-.966.702.369-1.135-.965-.701h1.193l.369-1.135zM20.434 18.576l.368 1.134h1.193l-.965.702.369 1.134-.965-.7-.966.7.369-1.134-.965-.702h1.193l.369-1.134zM12.261 10.5l.369 1.135h1.193l-.965.7.368 1.136-.965-.702-.965.702.369-1.135-.966-.701h1.194l.368-1.135zM13.227 6.018l.369 1.134h1.193l-.965.702.368 1.134-.965-.7-.965.7.369-1.134-.966-.702h1.194l.368-1.134zM16.125 17.61l.369 1.134h1.193l-.965.702.368 1.134-.965-.7-.965.7.369-1.134-.966-.702h1.194l.368-1.134zM13.227 14.712l.369 1.134h1.193l-.965.702.368 1.134-.965-.7-.965.7.369-1.134-.966-.702h1.194l.368-1.134zM16.299 3.294l.369 1.134h1.193l-.965.702.368 1.134-.965-.701-.965.701.369-1.134-.966-.702h1.193l.369-1.134z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.817 10.326l-.369 1.135h-1.193l.966.701-.37 1.135.966-.702.965.702-.368-1.135.965-.701h-1.193l-.369-1.135zM27.851 5.844l-.368 1.135h-1.194l.966.7-.37 1.136.966-.702.965.702-.368-1.135.965-.701H28.22l-.369-1.135zM24.953 17.436l-.369 1.134h-1.193l.966.702-.37 1.135.966-.702.965.702-.368-1.135.965-.701h-1.193l-.369-1.135zM27.851 14.538l-.368 1.134h-1.194l.966.702-.37 1.135.966-.702.965.702-.368-1.135.965-.701H28.22l-.369-1.135zM24.78 3.12l-.37 1.134h-1.192l.965.702-.369 1.134.965-.7.965.7-.368-1.134.965-.702h-1.193l-.369-1.134z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEu);
export default __webpack_public_path__ + "static/media/flag_eu.f3b755938ada226276c220a1693fcfca.svg";
export { ForwardRef as ReactComponent };